import {Routes} from '@angular/router';
import {SettingsPageComponent} from '../settings/pages/settings-page/settings-page.component';
import {AuthGuardService} from '../auth/services/authGuard/auth-guard.service';
import {TestingPageComponent} from '../_testing-ground/testing-page/testing-page.component';
import {ResourcesPageComponent} from '../video/resources-page/resources-page.component';
import {HeadlessPageComponent} from '../headless/pages/headless-page/headless-page.component';
import {AppComponent} from '../app.component';

export class AppRoutes {

  static routes: Routes = [
    {
      path: 'home',
      loadChildren: () => import('../home/home.module').then(m => m.HomeModule),
    },
    {
      path: 'appointments',
      loadChildren: () => import('../appointment/appointment.module').then(m => m.AppointmentModule),
    },
    {
      path: 'categories',
      loadChildren: () => import('../category/category.module').then(m => m.CategoryModule),
    },
    {
      path: 'contacts',
      loadChildren: () => import('../customers/customers.module').then(m => m.CustomersModule),
    },
    {
      path: 'snippets',
      loadChildren: () => import('../snippet/snippet.module').then(m => m.SnippetModule),
    },
    {
      path: 'jobs',
      loadChildren: () => import('../job/job.module').then(m => m.JobModule),
    },
    {
      path: 'communications',
      loadChildren: () => import('../communication/communication.module').then(m => m.CommunicationModule),
    },
    {
      path: 'docs',
      loadChildren: () => import('../docs/docs.module').then(m => m.DocsModule),
    },
    {
      path: 'settings',
      component: SettingsPageComponent,
      canActivate: [AuthGuardService]
    },
    {
      path: 'test',
      component: TestingPageComponent,
      canActivate: [AuthGuardService]
    },
    {
      path: 'resources',
      component: ResourcesPageComponent,
      canActivate: [AuthGuardService]
    },
    {
      path: 'headless',
      component: HeadlessPageComponent,
      children: [
        {
          path: '**',
          component: HeadlessPageComponent,
        }
      ]
    },
    {
      path: '**',
      component: AppComponent,
    }
  ];
}
